import type { ReactNode } from "react";

export const EYEBROW_STYLE = {
	fontFamily: "var(--font-mono)",
	fontSize: 11,
	fontWeight: 600,
	letterSpacing: "0.18em",
	textTransform: "uppercase",
	color: "var(--color-dashboard-muted)",
} as const;

/** Mono uppercase eyebrow over an italic display title. */
export function SectionHeading({
	eyebrow,
	title,
	size = 28,
}: {
	eyebrow: string;
	title: ReactNode;
	size?: number;
}) {
	return (
		<div className="space-y-1">
			<p style={EYEBROW_STYLE}>{eyebrow}</p>
			<h2
				style={{
					fontFamily: "var(--font-display)",
					fontSize: size,
					fontWeight: 500,
					fontStyle: "italic",
					color: "var(--color-dashboard-text)",
					marginTop: 4,
					lineHeight: 1.1,
				}}
			>
				{title}
			</h2>
		</div>
	);
}
